<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header btn-holder tab-nav-holder">
      <div class="col-sm-12 nav-tab-holder">
        <ul class="nav nav-tabs" role="tablist">
          <li>
            <a (click)="activeTab = tabs.DiscountCode" [class.active]="activeTab === tabs.DiscountCode">
              Discount Code
              <app-page-help articleId="xz71x6ks8n"></app-page-help>
            </a>
          </li>
          <li *ngIf="data.item?.id">
            <a (click)="activeTab = tabs.Activities" [class.active]="activeTab === tabs.Activities"> Activity </a>
          </li>
          <li *ngIf="data.item?.id">
            <a (click)="activeTab = tabs.Logs" [class.active]="activeTab === tabs.Logs"> Logs </a>
          </li>
        </ul>
      </div>
      <a (click)="close()" class="cstm-close" data-dismiss="modal" aria-label="Close">
        <span class="fas fa-times"></span>
      </a>
    </div>
    <div class="modal-body p-3">
      <div class="tab-content">
        <app-discount-code-detail
          [item]="data.item"
          (saved)="onSaved()"
          primaryBtnClass="btn btn-success text-uppercase"
          *ngIf="activeTab === tabs.DiscountCode"
        ></app-discount-code-detail>
        <app-discount-code-bookings
          [item]="data.item"
          *ngIf="activeTab === tabs.Activities"
        ></app-discount-code-bookings>

        <app-discount-code-logs [item]="data.item" *ngIf="activeTab === tabs.Logs"></app-discount-code-logs>
      </div>
    </div>
  </div>
</div>
